module.exports = __webpack_public_path__ + "media/images/claim_profile/Group 17-fc40c6c52e48ce5783d5f16f1acc4f52.png";